export const APP_SECTIONS_HASH = {
  order: {
    economicResults: 'economicResults',
    warnings: 'warnings',
    info: 'info',
    invested: 'invested',
    documents: 'documents',
    about: 'about',
    news: 'news',
    collaterals: 'collaterals',
  }
};
